import type {ClipboardEvent} from 'react';
import Resizer from 'react-image-file-resizer';
import FileUploader from 'src/modules/shared/fileUpload/fileUploader';

const CLIPBOARD_PASTE_MAX_PX = 600;

export function getClipboardImageFiles(e: ClipboardEvent): File[] {
  const out: File[] = [];
  const items = e.clipboardData?.items;
  if (items) {
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.kind === 'file' && item.type.startsWith('image/')) {
        const f = item.getAsFile();
        if (f) out.push(f);
      }
    }
  }
  if (out.length) return out;
  const files = e.clipboardData?.files;
  if (files?.length) {
    for (let i = 0; i < files.length; i++) {
      const f = files[i];
      if (f.type.startsWith('image/')) out.push(f);
    }
  }
  return out;
}

function dataUrlToFile(dataUrl: string, filename: string): File {
  const arr = dataUrl.split(',');
  const mimeMatch = arr[0].match(/:(.*?);/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/jpeg';
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new File([u8arr], filename, {type: mime});
}

export function resizeImageFileForPaste(file: File): Promise<File> {
  return new Promise((resolve, reject) => {
    try {
      Resizer.imageFileResizer(
        file,
        CLIPBOARD_PASTE_MAX_PX,
        CLIPBOARD_PASTE_MAX_PX,
        'JPEG',
        100,
        0,
        (uri) => {
          const dataUrl = typeof uri === 'string' ? uri : String(uri);
          resolve(dataUrlToFile(dataUrl, `paste-${Date.now()}.jpg`));
        },
        'base64',
      );
    } catch (err) {
      reject(err);
    }
  });
}

/**
 * Redimensiona y sube imágenes del portapapeles; devuelve `currentFiles` concatenado con los nuevos ítems tipo FileUploader.
 */
export async function uploadAndAppendImagesFromClipboard(
  rawFiles: File[],
  storage: any,
  currentFiles: any[] | undefined,
  max?: number,
): Promise<any[]> {
  const current = Array.isArray(currentFiles) ? [...currentFiles] : [];
  if (max !== undefined && max <= current.length) {
    return current;
  }

  const resized: File[] = [];
  for (const f of rawFiles) {
    resized.push(await resizeImageFileForPaste(f));
  }

  const out = [...current];
  for (const file of resized) {
    if (max !== undefined && out.length >= max) {
      break;
    }
    FileUploader.validate(file, {storage, image: true});
    const newFile = await FileUploader.upload(file, {storage, image: true});
    out.push(newFile);
  }
  return out;
}
